import {
  Environment,
  Network,
  RecordSource,
  RequestParameters,
  Store,
  Variables,
} from 'relay-runtime'
import { cookies, CookieType } from './state/cookies'

export const fetchGraphQL = (query: string, variables: Variables) => {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  }
  const auth = cookies.get(CookieType.AUTH.toString())
  if (auth != null) {
    headers['Authorization'] = `Bearer ${auth.token}`
  }
  return fetch(
    process.env.REACT_APP_BASE_URL != null
      ? process.env.REACT_APP_BASE_URL
      : '',
    {
      credentials: 'include',
      mode: 'cors',
      method: 'POST',
      headers,
      body: JSON.stringify({
        query,
        variables,
      }),
    }
  ).then((response) => response.json())
}

export const fetchRelay = (request: RequestParameters, variables: Variables) =>
  fetchGraphQL(request.text!, variables)

/**
 * The admin-panel GraphQL types (AdminAccount, AdminBrand, AdminUser, …) reuse
 * the underlying entity ids, which would collide in Relay's store with the
 * canonical Account/Brand/User records (same id, different __typename).
 * Namespace the admin records by typename so they get distinct store keys.
 * The `id` field values themselves are unchanged (still raw uuids for mutations).
 */
const getDataID = (
  fieldValue: Record<string, unknown>,
  typeName: string
): string | undefined => {
  const id = fieldValue.id
  if (id == null) return undefined
  return typeName.startsWith('Admin') ? `${typeName}:${id}` : String(id)
}

const relay = new Environment({
  network: Network.create(fetchRelay),
  store: new Store(new RecordSource()),
  getDataID,
})

export default relay
